import * as React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardHeader,
  CardTitle,
  CardImg,
  CardBody,
  CardFooter,
  Button,
  Row,
  Col
} from "shards-react"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"

class AdmissionsPage extends React.Component {
  constructor(props) {
    super(props)

    this.routify = this.routify.bind(this)

    this.state = {
      country: getCountry(this.props.pageContext.countryCode),
      routes: require("../data/routes.json")
    }
  }

  routify(route) {
    return "/" + this.state.country.slug + route
  }

  render() {
    return (
      <Layout countryCode={this.props.pageContext.countryCode || "JM"}>
        <SEO
          countryCode={this.props.pageContext.countryCode || "JM"}
          title="About Us"
          description=""
        />

        <br />
        <Container>
          <p>
            CSG Learning Institute orginally started as @cxcspanish on Instagram
            in August 2019 with the aim of providing online classes in CSEC
            Spanish to students who needed help. During the Covid-19 pandemic,
            we rebranded to @cxguide and provided online resources in all
            subject areas for CSEC and CAPE students, where we reached over
            30,000 students from across the Caribbean.
          </p>

          <p>
            Today, we are a registered Institution that offers CSEC and CAPE
            classes, as well as training and development in a wide range of
            diplomas and certifications including the Diplomas in Spanish,
            French and more.
          </p>
        </Container>
      </Layout>
    )
  }
}

export default AdmissionsPage
